import { createContext, useContext, useState } from "react";
import { toast } from "sonner";

const LocCtx = createContext(null);
const DEFAULT = { lat: 12.9791, lng: 80.2209, label: "Velachery, Chennai" };

const load = (k, d) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? d;
  } catch {
    return d;
  }
};

export function LocationProvider({ children }) {
  const [loc, setLocState] = useState(load("sd_loc", DEFAULT));
  const [radius, setRadiusState] = useState(load("sd_radius", 5));

  const setLoc = (l) => {
    setLocState(l);
    localStorage.setItem("sd_loc", JSON.stringify(l));
  };
  const setRadius = (r) => {
    setRadiusState(r);
    localStorage.setItem("sd_radius", JSON.stringify(r));
  };
  const detect = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) {
        toast.error("Location is not supported on this device. Search your area instead.");
        return resolve(false);
      }
      navigator.geolocation.getCurrentPosition(
        (p) => {
          setLoc({ lat: +p.coords.latitude.toFixed(5), lng: +p.coords.longitude.toFixed(5), label: "Current location" });
          resolve(true);
        },
        () => {
          toast.error("Location permission denied. Search for your area manually.");
          resolve(false);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    });

  return <LocCtx.Provider value={{ loc, radius, setLoc, setRadius, detect }}>{children}</LocCtx.Provider>;
}

export const useLoc = () => useContext(LocCtx);

export async function geocode(q) {
  const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=6&q=${encodeURIComponent(q)}`, {
    headers: { "Accept-Language": "en" },
  });
  const data = await r.json();
  return data.map((d) => ({ lat: +(+d.lat).toFixed(5), lng: +(+d.lon).toFixed(5), label: d.display_name.split(",").slice(0, 3).join(",") }));
}
